<form [formGroup]="flightDepartureForm">
  <mat-form-field appearance="outline" (click)="picker.open()">
    <mat-label>{{ 'FORM.DEPARTURE_DATE' | transloco }}</mat-label>
    <input matInput [min]="startDate" [matDatepicker]="picker" formControlName="flightDepartureDate"
      (dateChange)="getDepartureFlightsByDate($event);">
    <!-- getAvailableParkings($event)" -->
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker touchUi #picker></mat-datepicker>
    @if (!flightDepartureForm.controls.flightDepartureDate.valid &&
    flightDepartureForm.controls.flightDepartureDate.touched) {
    <mat-error>
      {{ 'ERROR.DATE' | transloco }}
    </mat-error>
    }
  </mat-form-field>

  <mat-form-field class="example-full-width" appearance="fill">
    @if (isLoading) {
    <mat-label>{{ 'FORM.FETCH_FLIGHTS' | transloco }}</mat-label>
    }
    @if (!isLoading) {
    <mat-label>{{ 'FORM.DEPARTURE_FLIGHTNUMBER' | transloco }}</mat-label>
    }
    <input type="text" matInput formControlName="flightNumber" [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayDepartureFlight"
      (optionSelected)="onDepartureFlightChange($event)">
      @for (option of filteredFlightOptions | async; track option) {
      <mat-option [value]="option">
        <div class="flex-row">
          <span class="font-weight-bold mr-2">
            {{option.flightId}}
          </span>
          @if (translate.getActiveLang() === 'sv') {
          <span class="font-weight-light">{{option.arrivalAirportSwedish}}</span>
          }
          @if (translate.getActiveLang() === 'en') {
          <span class="font-weight-light">{{option.arrivalAirportEnglish}}</span>
          }
          <span class="font-weight-light code-share">&nbsp;{{option.codeShareData}}</span>
          <div class="spacer"></div>
          <span class="font-weight-light"> Kl:
            {{option.departureTime.scheduled | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      }
    </mat-autocomplete>
    @if (isLoading) {
    <mat-spinner matSuffix color="accent" diameter="20">
    </mat-spinner>
    }
    @if (!isLoading && !flightDepartureForm.controls.flightNumber.value) {
    <mat-icon matSuffix>flight_takeoff</mat-icon>
    }
    @if (flightDepartureForm.controls.flightNumber.value) {
    <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="resetDepartureFlight()">
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-form-field>
  @if (flightDepartureForm.controls.flightNumber.invalid) {
  <span class="mat-error">
    {{ 'ERROR.DEPARTURE_FLIGHTNUMBER' | transloco }}
  </span>
  }

  @if (parking) {
  <mat-form-field appearance="outline">
    <mat-label>{{ 'FORM.ARRIVAL_TIME' | transloco }}</mat-label>
    <mat-select formControlName="parkingfrom" (selectionChange)="onParkingStartChange($event)">
      <mat-option [value]="this.arriveAtParking270Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.4.5_HOURS_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking270Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking255Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.4.25_HOURS_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking255Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking240Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.4_HOURS_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking240Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking225Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.3.75_HOURS_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking225Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking210Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.3.5_HOURS_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking210Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking195Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.3.25_HOURS_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking195Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking180Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.3_HOURS_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking180Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking165Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.2.75_HOURS_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking165Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking150Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.2.5_HOURS_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking150Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking135Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.2.25_HOURS_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking135Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking120Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.2_HOURS_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking120Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking105Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.1.75_HOUR_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking105Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking90Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.1.5_HOUR_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking90Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking75Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.1.25_HOUR_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking75Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      <mat-option [value]="this.arriveAtParking60Min">
        <div class="flex-row">
          <span class="mr-2">
            {{ 'PLACEHOLDER.1_HOUR_BEFORE' | transloco }}
          </span>
          <div class="spacer"></div>
          <span class="font-weight-light">Kl:
            {{this.arriveAtParking60Min | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
    </mat-select>
    <mat-icon matSuffix>schedule</mat-icon>
  </mat-form-field>
  }
</form>